import React from "react";
import "./Footer.css";
import { data } from "../../constants";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";
import { motion } from "framer-motion";
import { gtagSendEvent } from "../../utils/gtaghelper";

const Footer = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    >
      <footer>
        <div className="row align-items-center">
          {/* Brand */}
          <div className="col-md-2 col-12">
            <h1
              style={{
                fontSize: "40px",
                textDecorationColor: "#b9ff66",
                textDecorationLine: "underline",
              }}
            >
              Quantech
            </h1>
          </div>

          {/* Menu */}
          <div className="col-md-8 col-12">
            <ul className="navbar-footer">
              {data.Menu.slice(0, -1).map((item) => (
                <li key={item.text}>
                  <a href={item.link}>{item.text}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          {/* <div className="col-md-2 col-12 text-center text-md-end fs-4">
            <a
              style={{ color: "#b9ff66" }}
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/quantech.pro/"
            >
              <BsInstagram />
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a
              style={{ color: "#b9ff66" }}
              target="_blank"
              rel="noreferrer"
              href="https://api.whatsapp.com/send/?phone=916363053425&text=Hi%2C%20I%20would%20like%20to%20request%20website%20development%20services&type=phone_number&app_absent=0"
            >
              <BsWhatsapp />
            </a>
          </div> */}
        </div>

        <div className="row">
          {/* Vision */}
          <div className="col-md-4 col-12">
            <ul className="info-contact">
              <li>
                <span>Vision:</span>
              </li>
              <li>
                We build fast, modern websites that help businesses grow and
                convert better online.
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-md-4 col-12">
            <ul className="info-contact">
              <li>
                <span>Contact:</span>
              </li>

              <li>
                Email:{" "}
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href="mailto:hello@quantech.pro"
                >
                  hello@quantech.pro
                </a>
              </li>
            </ul>
          </div>

          {/* Trust micro-copy instead of heavy badges */}
          <div className="col-md-4 col-12">
            <ul className="info-contact">
              <li>
                <span>Why Quantech?</span>
              </li>
              <li>✔ Fast turnaround times</li>
              <li>✔ Transparent pricing</li>
              <li>✔ Conversion-focused design</li>
            </ul>
          </div>

          {/* Legal */}
          <div className="rights">
            <ul>
              <li key={"terms-and-conditions"}>
                <a href="/terms-and-conditions">Terms & Condition</a>
              </li>
              <li key={"privacy-policy"}>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li key={"refunds-and-cancellation"}>
                <a href="/refunds-and-cancellation">
                  Refunds & Cancellation
                </a>
              </li>
            </ul>
            <p>© {new Date().getFullYear()} Quantech. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </motion.div>
  );
};

export default Footer;